import { useState } from "react";

import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationOptions } from "@react-navigation/native-stack";
import { every } from "lodash";
import { ScrollView, View } from "react-native";
import { Divider, TouchableRipple } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import CombinationItem from "./CombinationItem";
import NoCombinations from "./NoCombinations";
import VariantOptionFilters from "./VariantOptionFilters";
import { Header, InfoBanner } from "../../../../components";
import useProductFormFormik from "../../hooks/useProductFormFormik";
import { StackScreenProps, productFormRoutes } from "../../navigation/types";
import { Combination } from "../../types";

type NavProps = StackScreenProps<typeof productFormRoutes.variantCombinations>;
export default function VariantCombinationsScreen({ navigation }: NavProps) {
  const {
    values: {
      variants: { variantsWithOptions },
      combinations,
    },
    status,
    setStatus,
  } = useProductFormFormik();

  const [filters, setFilters] = useState<string[]>([]);

  // remove from filters if already present, add to array if not present
  const toggleFilter = (f: string) => {
    setFilters((prev) =>
      prev.includes(f) ? prev.filter((p) => p !== f) : [...prev, f]
    );
  };

  const filteredCombinations = combinations.filter(({ variantOptions }) =>
    every(filters, (f) => variantOptions.map((vo) => vo.option).includes(f))
  );

  const selectCombination = (combination: Combination) => {
    setStatus({ ...status, selectedCombination: combination });
    navigation.navigate(productFormRoutes.combinationInventory);
  };

  const tailwind = useTailwind();

  return (
    <ScrollView>
      <InfoBanner
        text="Maneja el inventario por variantes seleccionando cada combinación de
        opciónes de tu producto."
      />

      <View style={tailwind("m-4")}>
        <VariantOptionFilters
          variantOptions={variantsWithOptions}
          enabledFilters={filters}
          toggleFilter={toggleFilter}
        />
      </View>

      {filteredCombinations.map((combination, index) => (
        <TouchableRipple
          key={index}
          onPress={() => selectCombination(combination)}
        >
          <View style={tailwind("px-4")}>
            {!!index && <Divider bold />}

            <View style={tailwind("py-4")}>
              <CombinationItem combination={combination} />
            </View>
          </View>
        </TouchableRipple>
      ))}
      {filteredCombinations.length === 0 && (
        <NoCombinations resetFilters={() => setFilters([])} />
      )}
    </ScrollView>
  );
}

export const variantCombinationsScreenOptions: NativeStackNavigationOptions = {
  header: () => <VariantCombinationsHeader />,
};

function VariantCombinationsHeader() {
  const { goBack } = useNavigation<NavProps["navigation"]>();
  return <Header title="Inventario por variantes" onBackPress={goBack} />;
}
